<!-- Ride Along Added Waypoints — centered modal, Mine / Others tabs -->
<div class="raw-overlay" (click)="onClose()">
  <div class="raw-modal" (click)="$event.stopPropagation()">
    <div class="raw-header">
      <span class="raw-header-spacer"></span>
      <h3>Added Waypoints</h3>
      <button class="raw-close" type="button" (click)="onClose()" aria-label="Close">×</button>
    </div>

    <div class="raw-tabs">
      <button class="raw-tab" [class.active]="tab === 'mine'" (click)="setTab('mine')">
        Mine ({{ mine.length }})
      </button>
      <button class="raw-tab" [class.active]="tab === 'others'" (click)="setTab('others')">
        Others ({{ others.length }})
      </button>
    </div>

    <div class="raw-body">
      <div class="raw-status" *ngIf="loading">Loading…</div>
      <div class="raw-status raw-status--error" *ngIf="!loading && error">{{ error }}</div>
      <div class="raw-status" *ngIf="!loading && !error && active.length === 0">
        No waypoints {{ tab === 'mine' ? 'added by you' : 'from others' }} yet.
      </div>

      <div class="raw-card" *ngFor="let wp of active" [class.removing]="wp.deleting">
        <div class="raw-icon">
          <img [src]="wp.icon" alt="" />
        </div>
        <div class="raw-info">
          <div class="raw-name">{{ wp.title }}</div>
          <!-- Mine: time under the name. Others: creator tag under the name, time on the right. -->
          <div class="raw-time" *ngIf="tab === 'mine' && wp.timeAgo">{{ wp.timeAgo }}</div>
          <span class="raw-creator" *ngIf="tab === 'others'">{{ wp.creatorName }}</span>
        </div>

        <div class="raw-time raw-time--trailing" *ngIf="tab === 'others' && wp.timeAgo">{{ wp.timeAgo }}</div>

        <ng-container *ngIf="wp.canDelete">
          <ng-container *ngIf="confirmingId === wp.id; else removeBtn">
            <div class="raw-confirm">
              <button class="raw-confirm-cancel" type="button" (click)="cancelRemove()">Cancel</button>
              <button class="raw-confirm-delete" type="button" (click)="confirmRemove(wp)">Delete</button>
            </div>
          </ng-container>
          <ng-template #removeBtn>
            <button class="raw-remove" type="button" [disabled]="wp.deleting" (click)="askRemove(wp)">
              {{ wp.deleting ? 'Removing…' : 'Remove' }}
            </button>
          </ng-template>
        </ng-container>
      </div>
    </div>
  </div>
</div>
